var _circle, _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnknown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    transform: "scale(.97194 1)",
    cx: 45,
    cy: 45,
    r: 45,
    fill: "#ffc107"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m45 58.88c-2.209 0-4-1.791-4-4v-4.543c0-1.101 0.454-2.153 1.254-2.908l8.083-7.631c1.313-1.377 2.035-3.181 2.035-5.087v-0.302c0-2.005-0.791-3.881-2.228-5.281-1.436-1.399-3.321-2.14-5.342-2.089-3.957 0.102-7.175 3.523-7.175 7.626 0 2.209-1.791 4-4 4s-4-1.791-4-4c0-8.402 6.715-15.411 14.969-15.623 4.183-0.109 8.138 1.439 11.131 4.357 2.995 2.918 4.645 6.829 4.645 11.01v0.302c0 4.027-1.546 7.834-4.354 10.72-0.04 0.041-0.08 0.081-0.121 0.12l-6.897 6.511v2.818c0 2.209-1.791 4-4 4z",
    fill: "#5d4037",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m45 71.96c-1.32 0-2.61-0.53-3.54-1.46-0.23-0.23-0.43-0.49-0.62-0.76-0.18-0.271-0.33-0.561-0.46-0.86-0.12-0.311-0.22-0.62-0.28-0.94-0.07-0.32-0.1-0.65-0.1-0.98 0-0.32 0.03-0.65 0.1-0.97 0.06-0.32 0.16-0.641 0.28-0.94 0.13-0.3 0.28-0.59 0.46-0.86 0.19-0.279 0.39-0.529 0.62-0.76 1.16-1.16 2.89-1.7 4.52-1.37 0.32 0.07 0.629 0.16 0.93 0.29 0.3 0.12 0.59 0.28 0.859 0.46 0.28 0.181 0.53 0.391 0.761 0.62 0.239 0.23 0.439 0.48 0.63 0.76 0.18 0.271 0.33 0.561 0.46 0.86 0.12 0.3 0.22 0.62 0.279 0.94 0.071 0.32 0.101 0.65 0.101 0.97 0 0.33-0.03 0.66-0.101 0.979-0.06 0.32-0.159 0.63-0.279 0.94-0.13 0.3-0.28 0.59-0.46 0.86-0.19 0.27-0.391 0.529-0.63 0.76-0.23 0.229-0.48 0.439-0.761 0.62-0.27 0.18-0.56 0.34-0.859 0.46-0.301 0.13-0.61 0.22-0.93 0.279-0.33 0.072-0.65 0.102-0.98 0.102z",
    fill: "#5d4037",
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -1,
    width: 582,
    height: 402,
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknown);
export default __webpack_public_path__ + "static/media/unknown.f79e421daf1d31b62ea7534778bbd69f.svg";
export { ForwardRef as ReactComponent };